var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarsEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 36,
    fill: "none",
    viewBox: "0 0 32 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2D2B32",
    strokeLinejoin: "round",
    d: "m18.353 10 1.525 4.122L24 15.647l-4.122 1.525-1.525 4.122-1.525-4.122-4.122-1.525 4.122-1.525L18.353 10Zm-7.059 9.412 1.332 1.962 1.962 1.332-1.961 1.332L11.293 26l-1.332-1.962L8 22.706l1.962-1.332 1.332-1.962Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsEmpty);
export default __webpack_public_path__ + "static/media/stars-empty.8a4986650a88ac5ca6170d50f297ff87.svg";
export { ForwardRef as ReactComponent };